import axios from 'axios';
import { setCookie } from '../utils/cookie';

export default async function getAccessToken() {
    
  let url = process.env.REACT_APP_OAUTH_URL;
  console.log("JUST URL:",url)
  const clientId = process.env.REACT_APP_CLIENT_ID;
  console.log(clientId)
  const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
  console.log(clientSecret)
  const grantType = process.env.REACT_APP_GRANT_TYPE;
  console.log(grantType)
  url = `${process.env.REACT_APP_API_URL}${url}`;
  console.log("FULL URL:",url)

  try {
    const tokenUrl = `${url}?grant_type=${grantType}&client_id=${clientId}&client_secret=${clientSecret}`;
    console.log("Token URL:",tokenUrl)
    const response = await axios.get(tokenUrl);
    const accessToken = response.data.access_token;
    setCookie('access_token', accessToken, 1);
    console.log('Access Token:', accessToken);
    return accessToken;

  } catch (error) {
    console.error('Error getting access token:', error);
    return null;
  }
};


